<template>
  <div class="user">
    <div class="user-top">
      <div>
        <el-row :gutter="16">
          <!-- <el-col :span="3"><el-input v-model="username" placeholder="请输入用户名"></el-input></el-col>
          <el-col :span="3"><el-input v-model="phoneNumber" placeholder="请输入手机号"></el-input></el-col>-->
          <el-col :span="3">
            <el-autocomplete
              class="inline-input"
              v-model="username"
              :fetch-suggestions="querySearch"
              clearable
              placeholder="请输入用户名"
            ></el-autocomplete>
          </el-col>
          <el-col :span="3">
            <el-autocomplete
              class="inline-input"
              v-model="phoneNumber"
              clearable
              :fetch-suggestions="querySearch1"
              placeholder="请输入手机号"
            ></el-autocomplete>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="accountType"
              clearable
              placeholder="请选择账户类型"
              @change="getUserID"
            >
              <el-option
                v-for="item in accountTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="companyType"
              clearable
              placeholder="请选择所属企业"
              @change="getCompanyId"
            >
              <el-option
                v-for="item in enterpriseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              class="buttonSearch"
              type="primary"
              icon="el-icon-search"
              @click="userSearch"
              >搜索</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-button
              @click="addUser(1)"
              :disabled="addPrivilege == 1"
              :class="[addPrivilege == 1 ? 'active' : '']"
              >新建用户 +</el-button
            >
          </el-col>
        </el-row>
      </div>

      <div style="clear: both"></div>
    </div>
    <div class="user-bottom">
      <el-table
        :data="tableData"
        :header-cell-style="{
          background: '#f3f3f3',
          color: '#323232',
          height: '50px',
        }"
        border
        style="width: 100%"
      >
        <el-table-column prop="nickname" label="用户名" width="120">
          <template slot-scope="scope">{{
            scope.row.nickname | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column
          prop="username"
          label="登录账号"
          width="110"
        ></el-table-column>
        <el-table-column prop="group_name" label="分组" width="100">
          <template slot-scope="scope">{{
            scope.row.group_name | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="account_type" label="账户类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.account_type == 1">管理后台</span>
            <span v-else-if="scope.row.account_type == 2">集团后台</span>
            <span v-else-if="scope.row.account_type == 3">大客户小程序</span>
            <span v-else-if="scope.row.account_type == 4">运维小程序</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width>
          <template slot-scope="scope">{{
            scope.row.email | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="is_customer" label="是否集团" width="80">
          <template slot-scope="scope">
            <span class="enable" v-if="scope.row.is_customer == 1">是</span>
            <span class="prohibit" v-else-if="scope.row.is_customer == 0"
              >否</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone_number"
          label="手机号"
          width="110"
        ></el-table-column>
        <el-table-column
          prop="enterprise_name"
          label="所属企业"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.enterprise_name | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="address" label="地址" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.address | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">{{
            scope.row.remarks | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="expired_time" label="有效登录时间" width="110">
          <template slot-scope="scope">{{
            scope.row.expired_time | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="last_login_time" label="最后登录时间">
          <template slot-scope="scope">{{
            scope.row.last_login_time | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button
              class="user-btn"
              @click="stationClick(scope.row)"
              :disabled="stationPrivilege == 1"
              :class="[stationPrivilege == 1 ? 'active' : '']"
              >场站</el-button
            >
            <el-button
              class="user-btn user-edit"
              @click="editClick(scope.row, 2)"
              :disabled="editPrivilege == 1"
              :class="[editPrivilege == 1 ? 'active' : '']"
              >编辑</el-button
            >
            <el-button
              class="user-btn user-delete"
              @click="deleteUser(scope.row)"
              :disabled="deletePrivilege == 1"
              :class="[deletePrivilege == 1 ? 'active' : '']"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentChange"
        :total="totalNum"
        :page-size="page_size"
      ></el-pagination>
    </div>
    <!-- 新建用户 -->
    <el-dialog
      title
      :visible.sync="newUserDialog"
      destroy-on-close
      @close="cancelClick()"
      customClass="new-user-dialog"
      width="934px"
      :close-on-click-modal="false"
    >
      <p class="title">新建用户</p>
      <div class="line"></div>
      <div class="new-user-content">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <div class="content-right">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>用户名：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="nickname"
                      clearable
                      placeholder="不超过10个字节，可中文可英文"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>账户类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="accountType"
                      placeholder="请选择类型"
                      @change="checkIfopen"
                    >
                      <el-option
                        v-for="item in accountTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details" v-if="typeOpen == true">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>集团编号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="jtid"
                      :disabled="jtidDia == 1"
                      placeholder="请输入集团编号"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>所属企业：</span>
                  </div>
                  <div class="details-r">
                    <el-select
                      v-model="enterprise_id"
                      clearable
                      placeholder="请选择所属企业"
                    >
                      <el-option
                        v-for="item in enterpriseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>邮箱：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="email"
                      clearable
                      placeholder="请输入邮箱"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title title-textarea">
                    <span class="star">*</span>
                    <span>地址：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      type="textarea"
                      clearable
                      :autosize="{ minRows: 1.3 }"
                      :maxlength="50"
                      class="textarea"
                      placeholder="不超过50字节，可中文可英文可数字"
                      v-model="address"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details" v-if="newOredit == true">
                  <div class="details-title title-textarea">
                    <span class="star">*</span>
                    <span>备注：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      type="textarea"
                      clearable
                      class="textarea"
                      :autosize="{ minRows: 1.3 }"
                      placeholder="不超过200字节，可中文可英文可数字"
                      v-model="remarks"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="11">
            <div class="grid-content bg-purple">
              <div class="content-left">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>登录账号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="loginAccount"
                      clearable
                      placeholder="不超过10个字节，使用英文和数字"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>是否集团：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="type"
                      placeholder="请选择类型"
                      @change="typeChange"
                    >
                      <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>分组：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="grouping"
                      :disabled="type == 1"
                      clearable
                      placeholder="请选择分组"
                    >
                      <el-option
                        v-for="item in groupingList"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>手机号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="phone_number"
                      clearable
                      placeholder="请输入手机号"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>有效登录时间：</span>
                  </div>
                  <div class="details-r">
                    <el-date-picker
                      v-model="expired_time"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </div>

                <div class="details" v-if="newOredit == false">
                  <div class="details-title title-textarea">
                    <span class="star">*</span>
                    <span>备注：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      type="textarea"
                      clearable
                      class="textarea"
                      :autosize="{ minRows: 1.3 }"
                      placeholder="不超过200字节，可中文可英文可数字"
                      v-model="remarks"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="button">
          <el-button class="button-cancel" @click="cancelClick()"
            >取消</el-button
          >
          <el-button class="button-confirm" @click="confirmClick()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 编辑弹框 -->
    <el-dialog
      title
      :visible.sync="editUserDialog"
      destroy-on-close
      @close="cancelClick()"
      customClass="new-user-dialog"
      width="934px"
      :close-on-click-modal="false"
    >
      <p class="title">编辑用户</p>
      <div class="line"></div>
      <div class="new-user-content">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <div class="content-right">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>用户名：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="nickname"
                      clearable
                      placeholder="不超过10个字节，可中文可英文"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>登录账号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="loginAccount"
                      clearable
                      placeholder="不超过10个字节，使用英文和数字"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>账户类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="accountType"
                      placeholder="请选择类型"
                      @change="checkIfopen"
                    >
                      <el-option
                        v-for="item in accountTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details" v-if="typeOpen == true">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>集团编号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="jtid"
                      :disabled="jtidDia == 1"
                      placeholder="请输入集团编号"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>所属企业：</span>
                  </div>
                  <div class="details-r">
                    <el-select
                      v-model="enterprise_id"
                      clearable
                      placeholder="请选择所属企业"
                    >
                      <el-option
                        v-for="item in enterpriseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>邮箱：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="email"
                      clearable
                      placeholder="请输入邮箱"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title title-textarea">
                    <span class="star">*</span>
                    <span>备注：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      type="textarea"
                      clearable
                      class="textarea"
                      :autosize="{ minRows: 1.3 }"
                      placeholder="不超过200字节，可中文可英文可数字"
                      v-model="remarks"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="11">
            <div class="grid-content bg-purple">
              <div class="content-left">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>手机号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="phone_number"
                      clearable
                      placeholder="请输入手机号"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>登陆密码：</span>
                  </div>
                  <div class="details-r">
                    <!-- <span style="display:inline-block;border:1px solid black;width:100px;height:40px;"></span>
                    <el-button native-type @click="resetPassword" type="info">重置密码</el-button>-->
                    <el-input
                      v-model="password"
                      disabled
                      style="width: 164px"
                    ></el-input>
                    <el-button
                      class="reset-password"
                      @click="passwordResetClick()"
                      :disabled="resetpPrivilege == 1"
                      >重置密码</el-button
                    >
                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>是否集团：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="type"
                      placeholder="请选择类型"
                      @change="typeChange"
                    >
                      <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>分组：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="grouping"
                      :disabled="type == 1"
                      clearable
                      placeholder="请选择分组"
                    >
                      <el-option
                        v-for="item in groupingList"
                        :key="item.id"
                        :label="item.group_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>有效登录时间：</span>
                  </div>
                  <div class="details-r">
                    <el-date-picker
                      v-model="expired_time"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title title-textarea">
                    <span class="star">*</span>
                    <span>地址：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      type="textarea"
                      clearable
                      :autosize="{ minRows: 1.3 }"
                      :maxlength="50"
                      class="textarea"
                      placeholder="不超过50字节，可中文可英文可数字"
                      v-model="address"
                    ></el-input>
                    <div style="clear: both"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="button">
          <el-button class="button-cancel" @click="cancelClick()"
            >取消</el-button
          >
          <el-button class="button-confirm" @click="confirmClick2()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 场站授权 -->
    <el-dialog
      title
      :visible.sync="stationDialog"
      @close="stationCancelClick"
      customClass="station-dialog"
      width="934px"
      :close-on-click-modal="false"
    >
      <p class="title">场站授权</p>
      <div class="line"></div>
      <div class="station-authorization">
        <div class="s-a-top">
          <div class="content">
            <div
              class="content-box"
              v-for="(item, index) in authorizedList"
              :key="index"
            >
              <span class="text">{{ item.station_name }}</span>
              <div class="triangle_border_nw"></div>
              <span
                class="fork"
                @click="deleteStationClick(item.station_name, item.station_id)"
                >×</span
              >
              <div style="clear: both"></div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
        <div class="s-a-center">
          <span class="name">场站</span>
          <el-select
            v-model="provincesName"
            clearable
            placeholder="请选择省份"
            @change="provinceChange"
          >
            <el-option
              v-for="item in provincesList"
              :key="item.province"
              :label="item.province"
              :value="item.province"
            ></el-option>
          </el-select>
          <el-select
            v-model="cityName"
            clearable
            placeholder="请选择城市"
            @change="getStation"
          >
            <el-option
              v-for="item in cityList"
              :key="item.city"
              :label="item.city"
              :value="item.city"
            ></el-option>
          </el-select>
          <div style="clear: both"></div>
        </div>
        <div class="s-a-bottom">
          <div class="content">
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                v-for="(item, index) in stationList"
                :key="index"
                :disabled="item.disabled"
                :label="item.station_name"
                @change="
                  (val) => {
                    checkboxChange(val, item.station_id, item.station_name);
                  }
                "
              ></el-checkbox>
            </el-checkbox-group>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
      <div class="pro-button">
        <el-button class="pro-btn pro-cancel" @click="stationCancelClick()"
          >取消</el-button
        >
        <el-button class="pro-btn pro-confirm" @click="stationConfirmClick()"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { parseDateFilter } from "@/filters";
export default {
  data() {
    return {
      restaurants: [],
      searchNumber: [],
      ifChoosejituan: false, //是否禁用“是否集团用户”框
      username: "", //查寻请输入用户名
      phoneNumber: "", //查询请输入电话号码
      timeout: null,
      typeOpen: false,
      newUserDialog: false,
      editUserDialog: false,
      stationDialog: false,
      password: "",
      newUserTitle: "新建用户",
      newOredit: true,
      tableData: [],
      // 一共多少页
      totalNum: 0,
      currentPage: 1, //当前页
      page: 1,
      page_size: 12,
      password: "******",
      provincesName: "",
      provincesList: [],
      cityName: "",
      cityList: [],
      stationList: [],
      checkList: [],
      authorizationId: "",
      nickname: "", //新建用户
      loginAccount: "",
      grouping: "",
      phone_number: "",
      address: "",
      expired_time: "",
      enterprise_id: "",
      userType: "", //选择用户类型
      groupingList: [], //获取用户类型列表
      companyType: "", //选择所属公司
      enterpriseList: [], //获取用户企业列表
      typeList: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      type: "",
      email: "",
      accountType: "", //账户类型
      accountTypeList: [
        //账户类型列表
        { value: 1, label: "管理后台" },
        { value: 2, label: "集团后台" },
        { value: 3, label: "大客户小程序" },
        { value: 4, label: "运维小程序" },
      ],
      groupStatus: "",
      remarks: "",
      authorizedList: [], //已授权
      editId: "",
      addPrivilege: 1, //新建
      editPrivilege: 1, //编辑
      stationPrivilege: 1, //场站
      deletePrivilege: 1, //删除
      resetpPrivilege: 1, //重置密码
      jtid: "",
      jtidDia: "",
    };
  },

  mounted() {
    this.restaurants = this.loadAll();
    this.getInputList();
    // this.restaurants=this.loadAll()
    this.$nextTick(function () {
      let role = [];
      role = this.$store.state.role;
      for (let i in role) {
        if (role[i].view_name == "系统管理") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "访问管理") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "新建用户") {
                  this.addPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "编辑用户"
                ) {
                  this.editPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "删除用户"
                ) {
                  this.deletePrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "场站授权"
                ) {
                  this.stationPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "重置密码"
                ) {
                  this.resetpPrivilege = 0;
                }
              }
            }
          }
        }
      }
      this.getDataList(1);
      this.getProvince();
      this.getEnterprises();
      this.getGroup();
    });
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearch1(queryString, cb) {
      var searchNumber = this.searchNumber;
      var results = queryString
        ? searchNumber.filter(this.createFilter(queryString))
        : searchNumber;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      return this.restaurants;
    },
    getInputList() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        // page: this.page,
        username: this.username,
        phone_number: this.phoneNumber,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/get_users",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          for (let i = 0; i < 10; i++) {
            this.restaurants.push({ value: su.data.data[i].nickname });
            this.searchNumber.push({ value: su.data.data[i].phone_number });
          }
        })
        .catch((err) => {});
    },
    checkIfopen(value) {
      if (value == 2) {
        // this.ifChoosejituan=true
        this.type = "1";
        this.newOredit = false;
        this.grouping = "18";
        if (this.type == "1") {
          this.typeOpen = true;
        } else {
          this.typeOpen = false;
          this.newOredit = true;
        }
      } else {
        this.type = "0";
        this.typeOpen = false;
        this.newOredit = true;
      }
    },
    resetPassword() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id: localStorage.getItem("customId"),
      };
      this.$api({
        method: "post",
        url: "/api.php/User/passwordReset",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        this.password = "123456";
      });
    },
    userSearch() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        page: this.page,
        username: this.username,
        phone_number: this.phoneNumber,
        enterprise_id: this.companyType,
        account_type: this.accountType,
        page_size: this.page_size,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/get_users",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          this.tableData = su.data.data;
          this.totalNum = Number(su.data._count);
          if (su.data.code == 303) {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },

    userSearch1() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        page: this.page,
        username: this.username,
        phone_number: this.phoneNumber,
        enterprise_id: this.companyType,
        page_size: this.page_size,
      };
      if (this.accountType == "管理后台") {
        params.account_type = 1;
      } else if (this.accountType == "集团后台") {
        params.account_type = 2;
      } else if (this.accountType == "大客户小程序") {
        params.account_type = 3;
      } else if (this.accountType == "运维小程序") {
        params.account_type = 4;
      }
      this.$api({
        method: "post",
        url: "/api.php/User/get_users",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          this.tableData = su.data.data;
          this.totalNum = Number(su.data._count);
          if (su.data.code == 303) {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getCompanyId(value) {
      this.companyType = value;
    },
    getUserID(value) {
      this.userType = value;
    },
    currentChange(data) {
      this.currentPage = data;
      this.getDataList1();
    },
    getDataList(page) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        page: page ? page : this.currentPage,
        page_size: this.page_size,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/get_users",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData = su.data.data;
            this.totalNum = Number(su.data._count);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getDataList1() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        page: this.currentPage,
        page_size: this.page_size,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/get_users",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData = su.data.data;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    cancelClick() {
      this.newUserDialog = false;
      this.editUserDialog = false;
      this.nickname = "";
      this.loginAccount = "";
      this.grouping = "";
      this.phone_number = "";
      this.address = "";
      this.expired_time = "";
      this.enterprise_id = "";
      this.type = "";
      this.email = "";
      this.groupStatus = "";
      this.remarks = "";
      this.editId = "";
      this.jtid = "";
      this.jtidDia = "";
      this.accountType = "";
    },
    getGroup() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/User/getGroup",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.groupingList = su.data.data;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    confirmClick() {
      var regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

      if (!isUserName(this.nickname)) {
        this.$message.warning("请输入正确用户名格式！");
        return;
      } else if (!isPhoneNumber(this.phone_number)) {
        this.$message.warning("请输入正确手机号码格式！");
        return;
      } else if (!isLoginUserName(this.loginAccount)) {
        this.$message.warning("请输入正确登录账号格式！");
        return;
      } else if (!isRemarks(this.remarks)) {
        this.$message.warning("请输入正确备注格式！");
        return;
      } else if (!isEmail(this.email)) {
        this.$message.warning("请输入正确邮箱格式！");
        return;
      }
      // else if (!isAddress(this.address)) {
      //   this.$message.warning("请输入正确地址格式！");
      //   return;
      // }
      else if (regEn.test(this.address) || regCn.test(this.address)) {
        this.$message.warning("地址不能包含非法字符");
        return;
      }

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        nickname: this.nickname,
        username: this.loginAccount,
        group_id: this.grouping,
        phone_number: this.phone_number,
        address: this.address,
        expired_time: this.expired_time
          ? parseDateFilter(this.expired_time, "yyyy-MM-dd")
          : "",
        enterprise_id: this.enterprise_id,
        is_customer: this.type,
        email: this.email,
        remarks: this.remarks,
        jtid: this.jtid,
        account_type: this.accountType,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/add_user",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.newUserDialog = false;
            this.typeOpen = false;
            this.$message.success(su.data.message);
            this.page = 1;
            this.currentPage = 1;
            this.getDataList(this.page);
            this.nickname = "";
            this.loginAccount = "";
            this.grouping = "";
            this.phone_number = "";
            this.address = "";
            this.expired_time = "";
            this.enterprise_id = "";
            this.type = "";
            this.email = "";
            this.groupStatus = "";
            this.remarks = "";
            this.jtid = "";
            this.jtidDia = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    confirmClick2() {
      var regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
      if (!isUserName(this.nickname)) {
        this.$message.warning("请输入正确用户名格式！");
        return;
      } else if (!isPhoneNumber(this.phone_number)) {
        this.$message.warning("请输入正确手机号码格式！");
        return;
      } else if (!isLoginUserName(this.loginAccount)) {
        this.$message.warning("请输入正确登录账号格式！");
        return;
      } else if (!isRemarks(this.remarks)) {
        this.$message.warning("请输入正确备注格式！");
        return;
      } else if (!isEmail(this.email)) {
        this.$message.warning("请输入正确邮箱格式！");
        return;
      } else if (regEn.test(this.address) || regCn.test(this.address)) {
        this.$message.warning("地址不能包含非法字符");
        return;
      }

      let params = {};
      if (this.type == 0) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          id: +this.editId,
          nickname: this.nickname,
          username: this.loginAccount,
          group_id: +this.grouping,
          phone_number: this.phone_number,
          address: this.address,
          expired_time: this.expired_time
            ? parseDateFilter(this.expired_time, "yyyy-MM-dd")
            : "",
          enterprise_id: +this.enterprise_id,
          is_customer: +this.type,
          email: this.email,
          customer_status: +this.groupStatus,
          remarks: this.remarks,
        };
      } else if (this.type == 1 && this.jtidDia == 0) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          id: +this.editId,
          nickname: this.nickname,
          username: this.loginAccount,
          group_id: +this.grouping,
          phone_number: this.phone_number,
          address: this.address,
          expired_time: this.expired_time
            ? parseDateFilter(this.expired_time, "yyyy-MM-dd")
            : "",
          enterprise_id: +this.enterprise_id,
          email: this.email,
          customer_status: +this.groupStatus,
          remarks: this.remarks,
          is_customer: this.type,
          jtid: this.jtid,
        };
      } else if (this.type == 1 && this.jtidDia == 1) {
        params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          id: +this.editId,
          nickname: this.nickname,
          username: this.loginAccount,
          group_id: +this.grouping,
          phone_number: this.phone_number,
          address: this.address,
          expired_time: this.expired_time
            ? parseDateFilter(this.expired_time, "yyyy-MM-dd")
            : "",
          enterprise_id: +this.enterprise_id,
          email: this.email,
          customer_status: +this.groupStatus,
          remarks: this.remarks,
        };
      }
      // return
      this.$api({
        method: "post",
        url: "/api.php/User/edit_user",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.newUserDialog = false;
            this.$message.success(su.data.message);
            this.page = 1;
            this.currentPage = 1;
            this.getDataList();
            this.userSearch1();
            this.nickname = "";
            this.loginAccount = "";
            this.grouping = "";
            // this.phone_number = "";
            this.address = "";
            this.expired_time = "";
            // this.enterprise_id = "";
            this.type = "";
            this.email = "";
            this.groupStatus = "";
            this.remarks = "";
            this.editId = "";
            this.jtid = "";
            this.jtidDia = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getProvince() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    provinceChange(province) {
      this.cityName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStation(city) {
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;

            for (let i in this.stationList) {
              for (let j in this.authorizedList) {
                if (
                  this.stationList[i].station_id ==
                  this.authorizedList[j].station_id
                ) {
                  this.checkList.push(this.authorizedList[j].station_name);
                }
              }
            }
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    stationClick(row) {
      this.authorizationId = row.id;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id: row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/getUserStation",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationDialog = true;
            this.authorizedList = su.data.data;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 303) {
            this.stationDialog = true;
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    stationCancelClick() {
      this.stationDialog = false;
      this.authorizedList = [];
      this.stationList = [];
      this.cityName = "";
      this.cityList = [];
      this.provincesName = "";
      this.checkList = [];
      this.authorizationId = "";
    },
    stationConfirmClick() {
      let list = [];
      for (let i in this.authorizedList) {
        list.push("" + this.authorizedList[i].station_id + "");
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id: this.authorizationId,
        station_id: list,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/userStationGrant",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationDialog = false;
            this.$message.success(su.data.message);
            this.page = 1;
            this.currentPage = 1;
            this.getDataList(this.page);
            this.authorizedList = [];
            this.stationList = [];
            this.cityName = "";
            this.cityList = [];
            this.provincesName = "";
            this.checkList = [];
            this.authorizationId = "";
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    addUser(num) {
      this.newOredit = num;
      this.newUserDialog = true;
      this.newUserTitle = "新建用户";
      this.getGroup();
      this.getEnterprises();
    },
    editClick(row, num) {
      localStorage.setItem("customId", row.id);
      this.newOredit = num;
      this.newUserDialog = true;
      this.editUserDialog = true;
      this.newUserTitle = "编辑用户";
      this.getGroup();
      for (let i in this.enterpriseList) {
        if (this.enterpriseList[i].name == row.enterprise_name) {
          this.enterprise_id = this.enterpriseList[i].id;
        }
      }
      if (row.account_type == 1) {
        this.accountType = "管理后台";
        this.typeOpen = false;
      } else if (row.account_type == 2) {
        this.accountType = "集团后台";
        this.typeOpen = true;
      } else if (row.account_type == 3) {
        this.accountType = "大客户小程序";
        this.typeOpen = false;
      } else if (row.account_type == 4) {
        this.accountType = "运维小程序";
        this.typeOpen = false;
      }
      this.editId = row.id;
      this.nickname = row.nickname;
      this.loginAccount = row.username;
      this.grouping = row.group_id;
      this.phone_number = row.phone_number;
      this.address = row.address;
      this.expired_time = row.expired_time;
      this.enterprise_id = this.enterprise_id;
      this.type = row.is_customer;
      this.email = row.email;
      this.groupStatus = row.customer_status;
      this.remarks = row.remarks;
      this.jtid = row.jtid;
      this.password = "******";
      if (this.type == 1) {
        this.jtidDia = 1;
      } else if (this.type == 0) {
        this.jtidDia = 0;
      }
    },
    deleteStationClick(name, id) {
      // console.log(name);
      // console.log(id);
      for (let i in this.authorizedList) {
        if (this.authorizedList[i].station_id == id) {
          this.authorizedList.splice(i, 1);
        }
      }
      for (let j in this.checkList) {
        if (this.checkList[j] == name) {
          this.checkList.splice(j, 1);
        }
      }
      // console.log(this.customerStations.current_signed);
      // return
    },
    checkboxChange(val, stationId, name) {
      if (val == true) {
        this.authorizedList.push({
          pay_type: this.settlementType,
          station_id: stationId,
          station_name: name,
        });
      } else if (val == false) {
        for (let i in this.authorizedList) {
          if (this.authorizedList[i].station_id == stationId) {
            this.authorizedList.splice(i, 1);
          }
        }
      }
    },
    getEnterprises() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/User/get_enterprises",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.enterpriseList = su.data.data;
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    deleteUser(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id: row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/User/delete_user",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.page = 1;
                this.currentPage = 1;
                this.getDataList(this.page);
                this.$message.success(su.data.message);
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    passwordResetClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id: this.editId,
        // password:this.password,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/passwordReset",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.password = "123456";
            this.$message.success(su.data.message);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    typeChange(data) {
      if (data == 1) {
        this.typeOpen = true;
        this.grouping = "18";
        this.newOredit = false;
      } else if (data == 0) {
        // this.grouping = "";
        this.typeOpen = false;
        this.groupStatus = "";
        this.newOredit = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user {
  .user-top {
    padding: 0 1%;
    .el-button {
      float: right;
      background-color: #f15500;
      color: #ffffff;
      border: none;
    }
    .el-autocomplete {
      float: left;
      margin-left: 1%;
    }

    .el-select {
      float: left;
    }

    .buttonSearch:hover {
      background-color: #0071bd;
      margin-left: 1%;
      float: left;
      border: 1px solid black;
    }
    .buttonSearch {
      background-color: #0071bd;
      margin-left: 1%;
      float: left;
    }
    .el-button.active {
      background-color: #a5a5a5;
    }
  }
  .user-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 24px;
    .user-btn {
      width: 54px;
      height: 26px;
      padding: 0;
      margin-left: 5px;
      background-color: #f15500;
      color: #feffff;
      border: none;
      font-size: 12px;
    }
    .user-btn.active {
      background-color: #a5a5a5;
    }
    .user-edit {
      background-color: #0071bd;
    }
    .user-edit.active {
      background-color: #a5a5a5;
    }
    .user-delete {
      background-color: #00b270;
    }
    .user-delete.active {
      background-color: #a5a5a5;
    }
    .enable {
      color: #01b170;
    }
    .prohibit {
      color: #ff0100;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 24px;
    margin-top: 20px;
    margin-right: 18px;
  }
  .new-user-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .new-user-content {
      .content-left {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            .star {
              color: #ee0002;
            }
            .resetButton {
              margin-bottom: 10px !important;
            }
          }
          .title-textarea {
            vertical-align: top;
            span {
              margin-top: 5px;
            }
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-input {
              width: 100%;
            }
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
        }
        .details-password {
          .details-r {
            .el-input {
              width: 64%;
            }
            .el-button {
              background-color: #f8f8f8;
              color: #565656;
            }
          }
        }
        .reset-password.active {
          background-color: #a5a5a5;
        }
      }
      .content-right {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            .star {
              color: #ee0002;
            }
          }
          .title-textarea {
            vertical-align: top;
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
        }
      }
      .textarea {
        ::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #c0c4cc;
          font-family: "microsoft yahei";
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #c0c4cc;
          font-family: "microsoft yahei";
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #c0c4cc;
          font-family: "microsoft yahei";
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #c0c4cc;
          font-family: "microsoft yahei";
        }
      }
    }
    .button {
      margin-top: 20px;
      .button-cancel {
        width: 26%;
        height: 46px;
        background-color: #0071bd;
        border: none;
        color: #ffffff;
      }
      .button-confirm {
        width: 26%;
        height: 46px;
        background-color: #02b36f;
        border: none;
        color: #ffffff;
      }
    }
  }
  .station-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .station-authorization {
      .s-a-top {
        width: 96%;
        min-height: 170px;
        margin-left: 2%;
        border: 1px solid #dedede;
        border-radius: 4px;
        .content {
          margin-left: 8px;
          margin-top: 10px;
          .content-box {
            display: inline-block;
            min-width: 90px;
            height: 36px;
            border: 1px solid #d3d3d3;
            position: relative;
            float: left;
            margin-left: 10px;
            padding-left: 10px;
            margin-bottom: 10px;
            .text {
              text-align: center;
              line-height: 36px;
              color: #555555;
            }
            .triangle_border_nw {
              width: 0;
              height: 0;
              // border-width:30px 30px 0 0;
              border-width: 0 15px 15px 0;
              border-style: solid;
              border-color: transparent #d3d3d3 transparent transparent;
              // margin: auto 40px;
              position: relative;
              float: right;
            }
            .fork {
              color: #555555;
              font-size: 5px;
              position: absolute;
              right: 0;
              top: -2px;
              cursor: pointer;
            }
          }
        }
      }
      .s-a-center {
        margin-top: 18px;
        margin-bottom: 18px;
        width: 96%;
        margin-left: 2%;
        .name {
          float: left;
          line-height: 40px;
          margin-right: 20px;
          color: #333333;
          font-weight: 600;
        }
        .el-select {
          float: left;
          margin-right: 12px;
        }
      }
      .s-a-bottom {
        width: 96%;
        min-height: 170px;
        margin-left: 2%;
        border: 1px solid #dedede;
        border-radius: 4px;
        .content {
          margin-left: 18px;
          margin-top: 20px;
          .el-checkbox {
            float: left;
            margin-bottom: 10px;
          }
        }
      }
    }
    .pro-button {
      margin-top: 40px;
      .pro-cancel {
        width: 16%;
        height: 40px;
        background-color: #0071bd;
        border: none;
        color: #ffffff;
      }
      .pro-confirm {
        width: 16%;
        height: 40px;
        background-color: #02b36f;
        border: none;
        color: #ffffff;
      }
    }
  }
}
.el-table__row.hover-row {
  .enable {
    color: #ffffff;
  }
  .prohibit {
    color: #ffffff;
  }
}
</style>
<style lang="scss">
.user .el-table--enable-row-hover .el-table__body tr:hover > td .user-edit {
  background-color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/components/systemManagement/user.vue